export class State {
  public name: string | null = null;
  public version: string | null = null;
}
